import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';

import './index.css';
import App from './App';

ReactDOM.render(
    <Provider store={store}>
        <React.StrictMode>
            <BrowserRouter basename='/redux-countries/'>
                <App />
            </BrowserRouter>
        </React.StrictMode>
    </Provider>,
    document.getElementById('root')
);
